module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/main-categories-icons/29-96c06c68e258e46e3e7800261169e558.svg";